module.exports = __webpack_public_path__ + "img/hybrid_desk_setup.c682212e.jpg";